import axios from 'axios';

class ApiRequest {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  buildConfig(method, url, data) {
    return {
      method,
      data,
      url,
      baseURL: this.baseURL,
    };
  }

  makeRequest(method, url, data) {
    return axios(this.buildConfig(method, url, data)).catch(error => {
      throw error;
    });
  }

  get(url, data) {
    return this.makeRequest('get', url, data);
  }

  post(url, data) {
    return this.makeRequest('post', url, data);
  }

  patch(url, data) {
    return this.makeRequest('patch', url, data);
  }

  delete(url) {
    return this.makeRequest('delete', url);
  }

  setToken(token) {
    this.token = token;
  }
}

export default ApiRequest;



// WEBPACK FOOTER //
// ./src/api/ApiRequest.js